/**
 * 商品详情宽表格横向拖动：
 * - scrollLeft = 按下时 scrollLeft − (当前 x − 按下时 x)
 * - 按下时不校验 canDrag（避免首帧 layout 未稳定导致永远不能拖）；move 里再写 scrollLeft
 * - 同时绑定 Touch（capture）+ Pointer（仅 mouse/pen，忽略 pointerType touch 以免与 touch 重复）
 *
 * 关闭：section[data-main-product][data-table-scroll="false"]
 *
 * 亦处理 Complete the set 区块内抽屉/折叠中的描述表格（不在 main-product 内）。
 */
(function () {
  var TRACK_CLASS = 'product-table-x-scroll__track';
  var BIND = 'productTableDragV7';
  /* 含「内联到商品栏」后脱离 .section-complete-the-set 祖先的情况 */
  var CTS_RTE_SEL =
    '.section-complete-the-set .drawer__content .rte, .section-complete-the-set .collapsible__content .rte, menu-drawer.section__drawer .drawer__content .rte, .section__drawer .collapsible__content .rte';

  function getProductSection(fromRoot) {
    var root = fromRoot && fromRoot.nodeType ? fromRoot : document;
    if (root.matches && root.matches('section[data-main-product]')) {
      return root;
    }
    if (root.id && String(root.id).indexOf('shopify-section-') === 0) {
      return root.querySelector('section[data-main-product]');
    }
    return root.querySelector && root.querySelector('section[data-main-product]');
  }

  function getTrack(outer) {
    if (!outer) return null;
    var el = outer.firstElementChild;
    while (el) {
      if (el.classList && el.classList.contains('product-table-x-scroll__track')) {
        return el;
      }
      el = el.nextElementSibling;
    }
    return null;
  }

  function ensureTrack(outer) {
    if (!outer || getTrack(outer)) return;
    var track = document.createElement('div');
    track.className = TRACK_CLASS;
    while (outer.firstChild) {
      track.appendChild(outer.firstChild);
    }
    outer.appendChild(track);
  }

  function applyScroll(el, startX, startScrollLeft, clientX) {
    var dx = clientX - startX;
    var rtl = getComputedStyle(el).direction === 'rtl';
    if (!rtl) {
      el.scrollLeft = startScrollLeft - dx;
    } else {
      el.scrollLeft = startScrollLeft + dx;
    }
  }

  function bindDragScroll(el) {
    if (el.dataset[BIND] === '1') return;
    var track = getTrack(el);
    if (!track) return;
    el.dataset[BIND] = '1';
    if (track.style) track.style.transform = '';

    var startX = 0;
    var startSl = 0;
    var activePointer = false;
    var activeTouch = false;
    var ptrId = null;

    function endDrag() {
      activePointer = false;
      activeTouch = false;
      ptrId = null;
      el.classList.remove('product-table-x-scroll--drag');
    }

    /* ----- Touch：捕获阶段，从 td 触摸也能到外容器 ----- */
    function onTouchStart(e) {
      if (e.touches.length !== 1) return;
      activeTouch = true;
      startX = e.touches[0].clientX;
      startSl = el.scrollLeft;
      el.classList.add('product-table-x-scroll--drag');
    }

    function onTouchMove(e) {
      if (!activeTouch || e.touches.length !== 1) return;
      applyScroll(el, startX, startSl, e.touches[0].clientX);
      if (e.cancelable) e.preventDefault();
    }

    function onTouchEnd() {
      activeTouch = false;
      el.classList.remove('product-table-x-scroll--drag');
    }

    var touchOpts = { capture: true, passive: false };
    el.addEventListener('touchstart', onTouchStart, {
      capture: true,
      passive: true,
    });
    el.addEventListener('touchmove', onTouchMove, touchOpts);
    el.addEventListener('touchend', onTouchEnd, { capture: true, passive: true });
    el.addEventListener('touchcancel', onTouchEnd, { capture: true, passive: true });

    /* ----- Pointer：只处理鼠标 / 触控笔，避免与 Touch 双份 ----- */
    if (window.PointerEvent) {
      el.addEventListener(
        'pointerdown',
        function (e) {
          if (e.pointerType === 'touch') return;
          if (e.button !== 0) return;
          activePointer = true;
          startX = e.clientX;
          startSl = el.scrollLeft;
          ptrId = e.pointerId;
          el.classList.add('product-table-x-scroll--drag');
          try {
            el.setPointerCapture(e.pointerId);
          } catch (_) {}
        },
        { passive: true }
      );

      el.addEventListener(
        'pointermove',
        function (e) {
          if (!activePointer || e.pointerId !== ptrId) return;
          if (e.pointerType === 'touch') return;
          applyScroll(el, startX, startSl, e.clientX);
          if (e.cancelable) e.preventDefault();
        },
        { passive: false }
      );

      el.addEventListener('pointerup', function (e) {
        if (e.pointerId !== ptrId) return;
        endDrag();
      });
      el.addEventListener('pointercancel', function (e) {
        if (e.pointerId !== ptrId) return;
        endDrag();
      });
      el.addEventListener('lostpointercapture', endDrag);
    }
  }

  function shouldSkipTable(table, productRoot) {
    if (!productRoot || !productRoot.contains(table)) return true;
    if (table.closest('.product-table-x-scroll, .size-guide-table-wrapper')) {
      return true;
    }
    if (table.parentElement && table.parentElement.closest('table')) return true;
    return false;
  }

  /** 主商品区外的表格（如 Complete the set 抽屉） */
  function shouldSkipTableOutsideMain(table) {
    if (table.closest('.product-table-x-scroll, .size-guide-table-wrapper')) {
      return true;
    }
    if (table.parentElement && table.parentElement.closest('table')) return true;
    return false;
  }

  function wrapTableElement(table) {
    if (table.closest('.product-table-x-scroll__track')) return;
    var parent = table.parentNode;
    if (!parent) return;

    var outer = document.createElement('div');
    outer.className = 'product-table-x-scroll';
    outer.setAttribute('tabindex', '0');
    outer.setAttribute('role', 'region');
    outer.setAttribute('aria-label', 'Scrollable table');
    var track = document.createElement('div');
    track.className = TRACK_CLASS;

    parent.insertBefore(outer, table);
    outer.appendChild(track);
    track.appendChild(table);
    bindDragScroll(outer);
  }

  function bindScrollContainersIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.product-table-x-scroll').forEach(function (el) {
      ensureTrack(el);
      bindDragScroll(el);
    });
  }

  function wrapTables() {
    var product = getProductSection(document);
    if (!product || product.dataset.tableScroll === 'false') return;

    product.querySelectorAll('table').forEach(function (table) {
      if (shouldSkipTable(table, product)) return;
      wrapTableElement(table);
    });

    document.querySelectorAll(CTS_RTE_SEL).forEach(function (rte) {
      rte.querySelectorAll('table').forEach(function (table) {
        if (shouldSkipTableOutsideMain(table)) return;
        wrapTableElement(table);
      });
    });

    bindScrollContainersIn(document);
  }

  function init() {
    wrapTables();
  }

  var moTimer;
  function observeProductRoot() {
    var product = getProductSection(document);
    if (!product || product.dataset.tableScroll === 'false') return;
    if (product.dataset.tableScrollMo === '1') return;
    product.dataset.tableScrollMo = '1';
    var mo = new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        init();
      }, 50);
    });
    mo.observe(product, { childList: true, subtree: true });
  }

  var roTimer;
  function observeResize() {
    var product = getProductSection(document);
    if (!product || product.dataset.tableScroll === 'false') return;
    if (typeof ResizeObserver === 'undefined') return;
    if (product.dataset.tableScrollRo === '1') return;
    product.dataset.tableScrollRo = '1';
    var ro = new ResizeObserver(function () {
      clearTimeout(roTimer);
      roTimer = setTimeout(function () {
        init();
      }, 80);
    });
    ro.observe(product);
  }

  function attachListeners() {
    document.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d.matches || !d.matches('details') || !d.open) return;
        var mainAccordion =
          d.matches('details.accordion__section') && d.closest('section[data-main-product]');
        var ctsDrawer =
          d.matches('details.drawer__container') &&
          (d.closest('.section-complete-the-set') || d.closest('menu-drawer.section__drawer'));
        if (!mainAccordion && !ctsDrawer) return;
        requestAnimationFrame(function () {
          init();
          setTimeout(function () {
            init();
          }, 120);
        });
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        if (
          e.target.closest &&
          e.target.closest('.main-product__tabs-wrapper .main-product__tab')
        ) {
          requestAnimationFrame(function () {
            init();
          });
          setTimeout(function () {
            init();
          }, 80);
        }
      },
      true
    );

    document.addEventListener('shopify:section:load', function (ev) {
      if (!ev.target || !ev.target.querySelector) return;
      init();
      setTimeout(function () {
        init();
      }, 100);
    });

    window.addEventListener('load', function () {
      init();
    });
  }

  init();
  observeProductRoot();
  observeResize();
  attachListeners();

  requestAnimationFrame(function () {
    init();
  });
  setTimeout(function () {
    init();
  }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      setTimeout(function () {
        init();
      }, 120);
    });
  }
})();
